export default __webpack_public_path__ + "static/media/skolskiprogram.e4cca734.jpg";